export default class MenuTrigger {
  constructor() {
		this.DOM = {}
		this.DOM.html      = document.getElementsByTagName('html')[0]
		this.DOM.trigger   = document.getElementById('js-menu-trigger')
		this.DOM.menuIcon  = this.DOM.trigger.querySelector('.l-menu-btn_icon')

		this.eventType = this._getEventType()
		this.handleEvent()
  }

	_getEventType() {
		return window.ontouchstart ? 'touchstart' : 'click'
	}

  handleEvent() {
		if ( !this.DOM.trigger ) { return }

		this.DOM.trigger.addEventListener( this.eventType, e => {
			e.stopPropagation()
			this.DOM.html.classList.toggle('menu-open')
      this.DOM.menuIcon.classList.toggle('active')
  	})
  }
}

new MenuTrigger()
